<template>
  <div>
    <div class="page-header">
      <div class="container-fluid d-flex align-items-center justify-content-between">
       <h2 class="h4 no-margin-bottom">Cari</h2>
       <div class="right-menu list-inline no-margin-bottom">
          <router-link to="/liste/cari"><button type="submit" class="btn submit bg-dark text-light">Liste</button>
          </router-link>
          <router-link :to="`/detay/cari/${id}`"><button type="submit" class="btn submit bg-dark text-light">Geri Dön</button>
          </router-link>
       </div>
      </div>
    </div>
    <section class="no-padding-top no-padding-bottom">
      <div class="container-fluid">
        <div class="row">
              <div v-for="(bir,iki) in this.$helper.groupByAdet(posts,'sd')" :key="bir"  class="col-md-3 col-sm-6">
                <div class="statistic-block block">
                  <div class="progress-details d-flex align-items-end justify-content-between">
                    <div class="title">
                      <div class="icon"><i class="icon-contract"></i></div><strong>{{iki}}</strong>
                    </div> 
                    <div class="number dashtext-2">{{bir}}</div>
                  </div>
                  <div class="progress progress-template">
                    <div role="progressbar" v-bind:style="{width :  (bir / posts.length)*100 + '%' }" class="progress-bar progress-bar-template dashbg-2"></div>
                  </div>
                </div>
              </div>
        </div>
        <div class="row">
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Cihaza Göre ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="st.chartOptions" :series="st.series"></apexchart>
                  </div>
                </div>
          </div>
          <div class="col-lg-6 col-12">
                <div class="pie-chart chart block">
                  <div class="title"><strong>Servis Nedeni ({{donem}})</strong></div>
                  <div class="pie-chart chart margin-bottom-sm">
                      <apexchart type="pie" width="100%" :options="sn.chartOptions" :series="sn.series"></apexchart>
                  </div>
                </div>
          </div>          
        </div>
        <div class="row">
          <div class="col-12">
            <div class="pie-chart chart block">
              <div class="title"><strong>Aylara Göre Ziyaret ({{donem}})</strong></div>
                <div class="pie-chart chart margin-bottom-sm">
                  <apexchart type="bar" width="100%" :options="ays.chartOptions" :series="ays.series"></apexchart>
                </div>
              </div>
          </div>
        </div>
      </div>
    </section>
    <div v-if="progres.inprogres">
      <div id="spinner-front" class="show"> <img src="/set/ajax-loader.gif"/><br>{{progres.mesaj}} ...</div>
      <div id="spinner-back" class="show"></div>
    </div>      
  </div>
</template>

<script>
export default {
   created() {
     this.progres.inprogres = true
     this.yetki();
  },
  data () {
    return {
        progres : {
          mesaj:'Bekleyiniz',
          inprogres:false
        } ,      
      id : this.$route.params.kod, // artık cihaz id bu
      posts : [],
      error :[],
      donem : this.$request.donem(),
      st:{},
      sn:{},
      ays:{},
      firma:this.$request.ayar().firmaid,
      p:this.$request.ayar().p

    }
  },
    methods : {
       yetki: function(){
          if (this.$helper.sayfayetki(321232)){
             this.getPostsAsync(this.id)
          }
          else{
                alert('Bu alanı kullanım yetkiniz yok')
                this.$router.go(-1)
          }
        },
        getPostsAsync (id){
          this.$request.get("servis/detay/cari/"+this.id+'/'+this.donem+'/'+this.p)
          .then(res => {
              this.posts = res.results.sort((t1,t2) => t2.sid < t1.sid ? -1 : 1)
              this.st = this.$helper.piechart(this.$helper.groupByAdet(res.results,'serino')),
              this.sn = this.$helper.piechart(this.$helper.groupByAdet(res.results,'sn')),
              this.aktarim(this.$helper.groupByAdet(res.results,'ay'),'ays')
           
            })
          .catch(err => {this.error.push(err)})
        },
        filter: function(tag) {
          this.currentTag = tag;
        },
        filteredItems: function(array,field) {
        var filter = this.currentTag;
        if (filter == 'All' ){
            return array
        }
        else{
              return array.filter(function(item) {
              return item[field].indexOf(filter) !== -1;
          });
        }
        },
        aktarim (array,keys){
          let serie = new Array;
          let label = new Array;
          Object.keys(array).forEach(function(key) {
            serie.push(array[key])
            label.push(key)
        })
                        this.ays = {
                          chartOptions: {
                          colors: ['#DB6574'],
                          plotOptions: {
                            bar: {
                              columnWidth: '60%',
                              //distributed: true
                            }
                          },
                        chart: {
                          type: 'bar',
                          height: 350,
                          foreColor: '#a5a7ab',
                          toolbar: {show: false,}
                        },
                        xaxis: {
                          categories: label,
                        }
                      },
                      series: [{
                        name: 'Ziyaret',
                        data: serie
                      }]
                        }
   this.progres.inprogres = false
        }

    }
  }
</script>



// WEBPACK FOOTER //
// src/views/cari/rapor.vue